module.exports = __webpack_public_path__ + "media/audio7.07c37505.mp3";